import React, { useState, useEffect } from "react";
import { Modal } from "@mantine/core";
import { ReactComponent as CloseIcon } from "../../../assets/iconamoon_close.svg";
import CustomButton from "../../../components/CustomButton";
import CustomSelect from "../../../components/customSelect/CustomSelect";
import { ReactComponent as LandingIcon } from "../../../assets/AirplaneLanding.svg";
import { ReactComponent as TakeoffIcon } from "../../../assets/AirplaneTakeoff.svg";
import { Link } from "react-router-dom";
import { useDisclosure } from "@mantine/hooks";
import AsyncSelect from "react-select/async";
import CheckEligibilityModal from "./checkEligibility/modal/EligibilityModal";
import { ReactComponent as ModalIcon } from "../../../assets/modalLogo.svg";
import { useForm, Controller } from "react-hook-form";
import axios from "axios";
import base_url from "../../../api/bootapi";

const Hero = () => {
  const options = ["Option 1", "Option 2", "Option 3"];

  const [opened, { open, close }] = useDisclosure(false);
  const [openEligibility, setOpenEligibility] = useState(false);
  const [selectedDeparture, setSelectedDeparture] = useState(null);
  const [selectedArrival, setSelectedArrival] = useState(null);

  const {
    control,
    setValue,
    handleSubmit,
    formState: { errors },
    watch,
  } = useForm();

  // Load flight details from localStorage on component mount
  useEffect(() => {
    const savedData = localStorage.getItem("flightDetailsData");
    if (savedData) {
      const parsedData = JSON.parse(savedData);
      if (parsedData.departureAirport) {
        setValue("departureAirport", parsedData.departureAirport);
        setSelectedDeparture(parsedData.departureAirport);
      }
      if (parsedData.arrivalAirport) {
        setValue("arrivalAirport", parsedData.arrivalAirport);
        setSelectedArrival(parsedData.arrivalAirport);
      }
    }
  }, [setValue]);

  // Update localStorage when airport selections change
  useEffect(() => {
    const departure = watch("departureAirport");
    const arrival = watch("arrivalAirport");

    if (departure || arrival) {
      const savedData = localStorage.getItem("flightDetailsData") || "{}";
      const parsedData = JSON.parse(savedData);

      localStorage.setItem(
        "flightDetailsData",
        JSON.stringify({
          ...parsedData,
          departureAirport: departure || parsedData.departureAirport,
          arrivalAirport: arrival || parsedData.arrivalAirport,
        })
      );
    }
  }, [watch("departureAirport"), watch("arrivalAirport")]);

  const handleEligibilityCheck = () => {
    const keysToRemove = [
      "claimType",
      "flightDetailsData",
      "flightCheckData",
      "claimQuestionsData",
      "emailAgreementData",
      "eligibilityStep",
    ];
    keysToRemove.forEach((key) => localStorage.removeItem(key));

    close();
    setOpenEligibility(true);
  };

  const clearLocalStorage = () => {
    const keysToRemove = [
      "travelerInformationData",
      "claimType",
      "OriginallyBookedFlightsData",
      "actualFlightDetailsData",
      "completedStep",
    ];

    keysToRemove.forEach((key) => localStorage.removeItem(key));
  };

  const loadAirportsOptions = async (inputValue) => {
    const airports = await fetchAllAirportslist(inputValue); // Pass inputValue to fetchAllAirportslist
    return airports;
  };

  const fetchAllAirportslist = async (searchTerm = "") => {
    try {
      const response = await axios.get(
        `${base_url.api1}/tourapp/flight_states_airports?sortby=airport_name`,
        {
          params: {
            search: searchTerm, // Pass searchTerm as a query parameter
          },
        }
      );

      // Process the response data
      const processedAirports = response.data.Airports.map((airport) => ({
        label: `${airport.airport_name.replace(
          /[\n\u0000-\u001F\u007F-\u009F]/g,
          ""
        )} (${airport.iata_code})`,
        value: airport.iata_code,
      }));

      return processedAirports;
    } catch (error) {
      console.error("Error fetching airports:", error);
      return [];
    }
  };

  const onCheckCompensation = () => {
    console.log(
      "Flight Details============================> ",
      selectedArrival,
      selectedDeparture
    );
    handleSubmit((data) => {
      if (data.departureAirport || data.arrivalAirport) {
        // open();
        if (selectedArrival.value !== selectedDeparture.value) {
          // setOpenEligibility(true);
          open();
        } else {
          return;
        }
      }
    })();
  };

  const [isDisable, setIsDisable] = useState(true);
  useEffect(() => {
    if (selectedArrival?.value === selectedDeparture?.value) {
      setIsDisable(true);
    } else {
      setIsDisable(false);
    }
  }, [selectedArrival, selectedDeparture]);

  const selectStyles = {
    control: (base) => ({
      ...base,
      background: "none !important",
      outline: "none !important",
      border: "none !important",
      boxShadow: "none !important",
      width: "250px",
    }),
    menu: (base) => ({
      ...base,
      background: "#ffffff",
    }),
    option: (base, { isFocused, isSelected }) => ({
      ...base,
      background: isSelected
        ? "#007bff"
        : isFocused
        ? "#f0f0f0"
        : "transparent",
      color: isSelected ? "#ffffff" : "#000000",
    }),
  };

  return (
    <div className="hero container-wrapper ">
      <div className="hero-left-side-wrapper">
        <h1 className="main-header-text">Flight Disrupted?</h1>
        <h1 className="main-header-text">Get the Compensation You Deserve!</h1>

        <h6>
          Whether your flight was delayed, canceled, or overbooked, Fly n’ Claim
          is here to help. Submit your claim in minutes and let our expert team
          handle the rest.
        </h6>
        <div className="hero-btn-wrapper">
          <Link to={"/start-your-claim"} onClick={clearLocalStorage}>
            <CustomButton btnText="Submit Your Claim" style={{whiteSpace:'nowrap'}}/>
          </Link>
           <Link to={"/start-group-claim"} onClick={clearLocalStorage}>
            <CustomButton btnText="6 Passengers or More" style={{whiteSpace:'nowrap'}}/>
          </Link>
          <Link to={"/claimstatus"}>
            <CustomButton btnText="Check Claim Status" type="secondary" style={{whiteSpace:'nowrap'}} />
          </Link>
        </div>
      </div>

      <div className="hero-check-compensation-wrapper">
        <div className="grid-two">
          <div className="custom-select" style={{ width: "100%", gap: "0" }}>
            <div
              className="select-box"
              style={{
                backgroundColor: "#FAFDFF",
              }}
            >
              <TakeoffIcon />
              <Controller
                name="departureAirport"
                control={control}
                rules={{ required: "This field is required" }}
                render={({ field }) => (
                  <AsyncSelect
                    {...field}
                    cacheOptions
                    defaultOptions
                    loadOptions={loadAirportsOptions}
                    placeholder="Departure airport"
                    value={field.value}
                    onChange={(selectedOption) => {
                      field.onChange(selectedOption);
                      setSelectedDeparture(selectedOption);
                    }}
                    styles={selectStyles}
                  />
                )}
              />
            </div>
            {errors.departureAirport && (
              <p className="errormessage">{errors.departureAirport.message}</p>
            )}
          </div>

          <div className="custom-select" style={{ width: "100%", gap: "0" }}>
            <div
              className="select-box"
              style={{
                backgroundColor: "#FAFDFF",
              }}
            >
              <LandingIcon />
              <Controller
                name="arrivalAirport"
                control={control}
                rules={{ required: "This field is required" }}
                render={({ field }) => (
                  <AsyncSelect
                    {...field}
                    cacheOptions
                    defaultOptions
                    loadOptions={loadAirportsOptions}
                    placeholder="Final destination airport"
                    value={field.value}
                    onChange={(selectedOption) => {
                      field.onChange(selectedOption);
                      setSelectedArrival(selectedOption);
                    }}
                    styles={selectStyles}
                  />
                )}
              />
            </div>
            {errors.arrivalAirport && (
              <p style={{}} className="errormessage">
                {errors.arrivalAirport.message}
              </p>
            )}
          </div>
        </div>
        <div className="check-btn">
          <CustomButton
            onClick={onCheckCompensation}
            type="danger"
            btnText={"check compensation"}
            disabled={isDisable}
          />
          {errors.arrivalAirport && (
            <p style={{}} className="errormessage">
              &nbsp;
            </p>
          )}
        </div>
      </div>

      <CheckEligibilityModal
        open={openEligibility}
        close={setOpenEligibility}
        selectedDeparture={selectedDeparture}
        selectedArrival={selectedArrival}
        setSelectedDeparture={setSelectedDeparture}
        setSelectedArrival={setSelectedArrival}
      />

      <Modal
        opened={opened}
        onClose={close}
        centered
        radius={"xl"}
        size={"lg"}
        withCloseButton={false}
      >
        <div className="modal-content-wrapper">
          <CloseIcon
            style={{
              position: "absolute",
              top: "24px",
              right: "24px",
              cursor: "pointer",
            }}
            onClick={close}
          />
          <ModalIcon />
          <h1 className="header" style={{ color: "#314064" }}>
            Check eligibility
          </h1>
          <p
            style={{ textAlign: "center", color: "#222222" }}
            className="sub-header"
          >
            Check if you're eligible for compensation in less than a minute!
            Answer a few quick questions to see how much you may be entitled to.
          </p>
          <CustomButton
            btnText={"Start My Eligibility Check"}
            flex={1}
            onClick={handleEligibilityCheck}
          />
        </div>
      </Modal>
    </div>
  );
};

export default Hero;
